import { MouseEventHandler } from "react";
import { MenuItem } from "@blueprintjs/core";

export const renderAddEmployerManually = (query: string, active: boolean, onClick: MouseEventHandler<HTMLElement>) => (
  <MenuItem
    key={"create-new-item"}
    icon={"add"}
    text={`Add "${query}" Manually?`}
    roleStructure={"listoption"}
    active={active}
    onClick={onClick}
  />
);
